import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "flex flex-col gap-4 w-full" }
const _hoisted_2 = { class: "flex items-center gap-3 pb-3 border-b border-gray-700" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", { class: "inline-flex items-center justify-center w-9 h-9 rounded-full bg-secondary text-white" }, " 🚍 ", -1)
const _hoisted_4 = { class: "flex-1 min-w-0" }
const _hoisted_5 = { class: "text-white font-semibold text-sm truncate" }
const _hoisted_6 = { class: "text-xs text-gray-400 truncate" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("p", { class: "text-xs text-gray-400" }, " Le chauffeur doit ouvrir ce lien sur son téléphone pour activer le suivi GPS. Scannez le QR code ou envoyez le lien par WhatsApp / SMS. ", -1)
const _hoisted_8 = { class: "flex justify-center bg-white p-3 rounded" }
const _hoisted_9 = ["src"]
const _hoisted_10 = {
  key: 1,
  class: "w-[220px] h-[220px] flex items-center justify-center text-gray-400 text-sm"
}
const _hoisted_11 = { class: "flex flex-col gap-1" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("p", { class: "text-gray-400 text-xs" }, "URL de suivi", -1)
const _hoisted_13 = { class: "flex flex-row items-stretch gap-2" }
const _hoisted_14 = ["value"]
const _hoisted_15 = /*#__PURE__*/_createElementVNode("p", { class: "text-[11px] text-amber-400/80 italic leading-snug" }, " ⚠️ Ce lien contient un jeton d'authentification. Ne le diffusez qu'au chauffeur concerné. ", -1)
const _hoisted_16 = { class: "flex flex-row items-end justify-end w-full" }

import { onMounted, ref } from "vue";
	import qrcode from "qrcode";
	import useNotyf from "@/composable/useNotyf";

	const modalName = "DriverLinkModal";
	
export default /*#__PURE__*/_defineComponent({
  __name: 'DriverLinkModal',
  props: {
    vehicle: {},
    url: {}
  },
  emits: ["close"],
  setup(__props: any, { emit: __emit }) {

	/**
	 * Modal that hands a per-vehicle tracking URL to a driver. The URL
	 * embeds the vehicle UUID + ingest token, so anyone holding it can
	 * post positions for that vehicle — keep the surface minimal:
	 * scannable QR (driver opens it on their phone) and a copy button
	 * for cases where SMS / WhatsApp is more convenient.
	 *
	 * The token comes from /tracking/{id}/token (FleetTrackingController
	 * @trackingToken). Closing the modal does NOT revoke it; rotation
	 * happens server-side on demand via the same endpoint.
	 */
	const props = __props;
	const emit = __emit;

	const notify = useNotyf();
	const qrDataUrl = ref<string>("");
	const copied = ref(false);

	const onModalClose = (e: any) => {
		if (e === modalName) emit("close");
	};

	const copyLink = async () => {
		try {
			await navigator.clipboard.writeText(props.url);
			copied.value = true;
			notify.success("Lien copié");
			setTimeout(() => { copied.value = false; }, 2000);
		} catch {
			notify.error("Impossible de copier le lien");
		}
	};

	const openInBrowser = () => {
		window.open(props.url, "_blank", "noopener,noreferrer");
	};

	const shareViaWhatsApp = () => {
		const msg = `Lien de suivi du véhicule ${props.vehicle?.matriculation || ""} : ${props.url}`;
		window.open("https://wa.me/?text=" + encodeURIComponent(msg), "_blank", "noopener,noreferrer");
	};

	onMounted(async () => {
		try {
			qrDataUrl.value = await qrcode.toDataURL(props.url, {
				margin: 1,
				width: 220,
				color: { dark: "#111827", light: "#ffffff" },
			});
		} catch (e) {
			console.warn("[DriverLinkModal] QR generation failed", e);
		}
	});

return (_ctx: any,_cache: any) => {
  const _component_ButtonTag = _resolveComponent("ButtonTag")!
  const _component_ModalPage = _resolveComponent("ModalPage")!

  return (_openBlock(), _createBlock(_component_ModalPage, {
    title: "Lien chauffeur",
    name: modalName,
    styleContent: "w-full",
    styleFooter: "w-full",
    onClose: onModalClose
  }, {
    content: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _hoisted_3,
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("p", _hoisted_5, _toDisplayString(_ctx.vehicle?.matriculation || _ctx.vehicle?.label || "Véhicule"), 1),
            _createElementVNode("p", _hoisted_6, _toDisplayString(_ctx.vehicle?.label || ""), 1)
          ])
        ]),
        _hoisted_7,
        _createElementVNode("div", _hoisted_8, [
          (qrDataUrl.value)
            ? (_openBlock(), _createElementBlock("img", {
                key: 0,
                src: qrDataUrl.value,
                alt: "QR code lien chauffeur",
                class: "w-[220px] h-[220px]"
              }, null, 8, _hoisted_9))
            : (_openBlock(), _createElementBlock("div", _hoisted_10, " Génération du QR… "))
        ]),
        _createElementVNode("div", _hoisted_11, [
          _hoisted_12,
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("input", {
              type: "text",
              readonly: "",
              value: _ctx.url,
              class: "flex-1 min-w-0 bg-secondary border border-gray-600 rounded px-3 py-2 text-xs text-white font-mono focus:outline-none focus:border-accent",
              onFocus: _cache[0] || (_cache[0] = ($event: any) => (($event.target as HTMLInputElement).select()))
            }, null, 40, _hoisted_14),
            _createElementVNode("button", {
              type: "button",
              class: _normalizeClass(["px-3 py-2 rounded text-xs text-white border border-secondary focus:outline-none whitespace-nowrap", copied.value ? 'bg-green-700' : 'bg-[#219152] hover:bg-[#167841]']),
              onClick: copyLink
            }, _toDisplayString(copied.value ? "✓ Copié" : "Copier"), 3)
          ])
        ]),
        _createElementVNode("div", { class: "flex flex-row gap-2" }, [
          _createElementVNode("button", {
            type: "button",
            class: "flex-1 px-3 py-2 rounded text-xs text-white bg-[#25D366] hover:bg-[#1da851] border border-secondary focus:outline-none",
            onClick: shareViaWhatsApp
          }, " 📱 WhatsApp "),
          _createElementVNode("button", {
            type: "button",
            class: "flex-1 px-3 py-2 rounded text-xs text-white bg-secondary hover:bg-gray-600 border border-gray-600 focus:outline-none",
            onClick: openInBrowser
          }, " 🌐 Ouvrir ")
        ]),
        _hoisted_15
      ])
    ]),
    footer: _withCtx(() => [
      _createElementVNode("div", _hoisted_16, [
        _createVNode(_component_ButtonTag, {
          label: "Fermer",
          activeIcon: false,
          css: "bg-gray-500 border-secondary text-white px-6 py-2 hover:bg-gray-600 focus:outline-none",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (emit('close')))
        })
      ])
    ]),
    _: 1
  }))
}
}

})